import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

import { renderInstructorPage } from './-route-wrappers';

const EditStudentNote = lazyRouteComponent(() => import('@/_instructor/customer-profile/edit-notes'));

export const Route = createFileRoute('/_instructor/student/notes/edit')({
  component: () => renderInstructorPage(EditStudentNote),
});
